import React from "react";

const Footer = () => {
  return (
    <>
      <div className="footer py-4 d-flex flex-lg-column" id="kt_footer">
        <div className="container-fluid d-flex flex-column flex-md-row flex-stack">
          <div className="text-dark order-2 order-md-1"></div>
          <ul className="menu menu-gray-600 menu-hover-primary fw-semibold order-1"></ul>
        </div>
      </div>
    </>
  );
};
export default Footer;
